(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.email-signup__form');
  if (form) {
    form.addEventListener('submit', function(e) {
      const marketingDataField = document.getElementById('MarketingData-{{ block.id }}');
      const phoneField = document.getElementById('PhoneInput-{{ block.id }}');
      // const colorFields = document.querySelectorAll('input[name="color_preference"]:checked');

      const selectedVariant = document.querySelector("input[name='color_preference']:checked")?.value;

      if(selectedVariant){
          const tagInput = document.querySelector("input[name='contact[tags]']");
          tagInput.value = `newsletter,waitlist,${selectedVariant}`;
      }
      
      let marketingData = '';
      
      // Add phone number if available
      if (phoneField && phoneField.value) {
        marketingData += 'Phone: ' + phoneField.value;
      }
      
      // // Add color preference if selected
      // if (colorFields.length > 0) {
      //   if (marketingData) marketingData += ' | ';
      //   marketingData += 'Color: ' + colorFields[0].value;
      // }
      
      // Update the hidden field
      if (marketingDataField) {
        marketingDataField.value = marketingData;
      }
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
